(function () {
  'use strict';

  var cfg = window.ultimateLiving || {};

  /* Site-wide toast (password reset confirmation, etc.) */
  function showToast(message, isError) {
    var t = document.querySelector('[data-site-toast]');
    if (!t) {
      t = document.createElement('div');
      t.setAttribute('data-site-toast', '');
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.className = 'site-toast';
      document.body.appendChild(t);
    }
    t.textContent = message;
    t.classList.toggle('site-toast--error', !!isError);
    t.classList.add('is-visible');
    clearTimeout(t._hideTimer);
    t._hideTimer = setTimeout(function () { t.classList.remove('is-visible'); }, 3200);
  }

  window.ultimateLiving = window.ultimateLiving || {};
  window.ultimateLiving.showToast = showToast;

  /* Announcement bar nav resets CSS animation */
  document.querySelectorAll('.ann-bar').forEach(function (bar) {
    var slides = bar.querySelector('.ann-bar__slides');
    if (!slides) return;
    bar.querySelectorAll('.ann-bar__nav').forEach(function (btn) {
      btn.addEventListener('click', function () {
        slides.style.animation = 'none';
        void slides.offsetWidth;
        slides.style.animation = '';
      });
    });
  });

  /* Mobile header nav */
  document.querySelectorAll('[data-nav-toggle]').forEach(function (toggle) {
    var panel = document.getElementById(toggle.getAttribute('aria-controls') || 'SiteNav');
    if (!panel) return;

    function closeNav() {
      toggle.setAttribute('aria-expanded', 'false');
      toggle.classList.remove('is-open');
      panel.classList.remove('is-open');
    }

    function openNav() {
      toggle.setAttribute('aria-expanded', 'true');
      toggle.classList.add('is-open');
      panel.classList.add('is-open');
    }

    toggle.addEventListener('click', function () {
      if (toggle.getAttribute('aria-expanded') === 'true') {
        closeNav();
      } else {
        openNav();
      }
    });

    panel.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeNav);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeNav();
    });

    window.addEventListener('resize', function () {
      if (window.innerWidth > 900) closeNav();
    });
  });

  /* Keep cart count in sync after AJAX cart changes */

  // Recharge encodes plan frequency as line quantity (3-month = qty 3). Count
  // subscription lines as 1 each so the badge reflects products, not units.
  function logicalCartCount(cart) {
    return (cart.items || []).reduce(function (sum, item) {
      return sum + (item.selling_plan_allocation ? 1 : item.quantity);
    }, 0);
  }

  function updateCartCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = String(count);
      el.setAttribute('data-cart-count', String(count));
      if (count > 0) {
        el.removeAttribute('hidden');
      } else {
        el.setAttribute('hidden', 'hidden');
      }
    });
  }

  window.ultimateLiving = window.ultimateLiving || {};
  window.ultimateLiving.updateCartCount = updateCartCount;
  window.ultimateLiving.logicalCartCount = logicalCartCount;

  window.ultimateLiving.fetchCart = function () {
    return fetch((cfg.routes && cfg.routes.cartUrl ? cfg.routes.cartUrl : '/cart') + '.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Cart fetch failed');
        return res.json();
      })
      .then(function (cart) {
        updateCartCount(logicalCartCount(cart));
        return cart;
      });
  };

  // Recharge Storefront Experiences fires these events on document after any
  // cart mutation (add, remove, quantity change). The detail object matches
  // Shopify's cart JSON shape so logicalCartCount works directly on it.
  // Spec: https://docs.rechargeapps.com/developer/storefront/storefront-experiences/javascript-events
  ['recharge:cart:updated', 'recharge:cart:item_added', 'recharge:cart:item_removed',
   'recharge:cart:item_quantity_updated'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      var cart = e.detail && (e.detail.cart || e.detail);
      if (cart && cart.items) {
        updateCartCount(logicalCartCount(cart));
      } else {
        window.ultimateLiving.fetchCart();
      }
    });
  });

  /* Footer columns: collapsible folders on mobile, always open on desktop.
     Rendered open in HTML (no-JS fallback = all open); here we collapse them
     below the mobile breakpoint and reopen on resize to desktop. */
  (function footerAccordion() {
    var cols = document.querySelectorAll('.footer__col');
    if (!cols.length) return;
    var mq = window.matchMedia('(max-width: 600px)');
    function sync() {
      var mobile = mq.matches;
      cols.forEach(function (col) {
        if (mobile) {
          col.removeAttribute('open');
        } else {
          col.setAttribute('open', '');
        }
      });
    }
    sync();
    if (mq.addEventListener) {
      mq.addEventListener('change', sync);
    } else if (mq.addListener) {
      mq.addListener(sync);
    }
  })();

  /* Smooth scroll for in-page anchors (Shop, Science) */
  document.querySelectorAll('a[href*="#"]').forEach(function (anchor) {
    anchor.addEventListener('click', function (e) {
      var href = anchor.getAttribute('href');
      if (!href || href === '#') return;
      var hashIndex = href.indexOf('#');
      if (hashIndex === -1) return;
      var path = href.slice(0, hashIndex) || window.location.pathname;
      var hash = href.slice(hashIndex);
      if (path !== window.location.pathname && path !== '/' && path !== '') return;
      var target = document.querySelector(hash);
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      history.pushState(null, '', hash);
    });
  });
})();
